import { LAZY_LOADED_ENTITIES } from "../../components/LazyLoadTable/LazyTable.constants";
import { LAZY_LOAD_ACTIONS } from "../thunks/lazyLoad.thunk";

interface lazyLoadSliceProps {
  [string: string]: {
    loading: false;
    error: {} | null;
    count: number;
    next: string | null;
    previous: string | null;
    results: [];
    page: number;
    pageSize: number;
    next_page_token?: string;
  };
}

const initialState: lazyLoadSliceProps = {
  [LAZY_LOADED_ENTITIES.TTC_CHAT_HISTORY]: {
    loading: false,
    error: null,
    count: 0,
    next: null,
    previous: null,
    results: [],
    page: 1,
    pageSize: 20,
  },
  [LAZY_LOADED_ENTITIES.ADK_TTC_CHAT_FILES]: {
    loading: false,
    error: null,
    count: 0,
    next: null,
    previous: null,
    results: [],
    page: 1,
    pageSize: 20,
    next_page_token: "",
  },
   [LAZY_LOADED_ENTITIES.ADK_TTC_CHAT_HISTORY]: {
    loading: false,
    error: null,
    count: 0,
    next: null,
    previous: null,
    results: [],
    page: 1,
    pageSize: 20,
  }
};

export default function lazyLoadReducer(state = initialState, action: any) {
  switch (action.type) {
    case LAZY_LOAD_ACTIONS.SET_DATA:
      var { entity, data } = action.payload;
      return {
        ...state,
        [entity]: {
          ...state[entity],
          ...data,
        },
      };

    case LAZY_LOAD_ACTIONS.REMOVE_ROW:
      var { rowId } = action.payload;
      entity = action.payload.entity;
      return {
        ...state,
        [entity]: {
          ...state[entity],
          results: state[entity].results.filter((row: any) => row.id !== rowId),
          count: state[entity].count - 1,
        },
      };

    case LAZY_LOAD_ACTIONS.UPDATE_ROW:
      var { conversationId } = action.payload;
      entity = action.payload.entity;
      data = action.payload.data;
      return {
        ...state,
        [entity]: {
          ...state[entity],
          results: state[entity].results.map((row: any) =>
            row.id === conversationId ? { ...row, ...data } : row
          ),
        },
      };

    default:
      return state;
  }
}
